import { useSetAtom } from "jotai";
import type { FunctionComponent } from "react";
import { startTransition } from "react";

import { useEditionValue } from "shared/lib/edition";
import { yieldToMain } from "shared/lib/utils";

import { hamburgerMenuAtom } from "scmp-app/components/hamburger-menu/atoms";
import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";

import IconMenu from "./menu.svg";
import { IconMenuContainer } from "./styles";

export type HeaderFeaturesHamburgerMenuProps = HeaderFeatureCommonProps;

export const HeaderFeaturesHamburgerMenu: FunctionComponent<HeaderFeaturesHamburgerMenuProps> = ({
  ...props
}) => {
  const setHamburgerMenuState = useSetAtom(hamburgerMenuAtom);
  const edition = useEditionValue();

  return (
    <IconMenuContainer
      {...getResponsiveProps(props)}
      onClick={() => {
        void (async () => {
          await yieldToMain({ priority: "user-blocking" });
          startTransition(() => {
            setHamburgerMenuState(current => ({
              ...current,
              isOpen: !current.isOpen,
            }));
          });
        })();

        void (async () => {
          await yieldToMain({ priority: "background" });
          sendGA4Tracking({
            action: "click",
            category: "menu",
            customized_parameters: {
              action_type: "open",
              edition,
              menu_type: "hamburger",
            },
            subcategory: "section",
          });
        })();
      }}
    >
      <IconMenu />
    </IconMenuContainer>
  );
};

HeaderFeaturesHamburgerMenu.displayName = "HeaderFeaturesHamburgerMenu";
